<template>
  <div
    class="chat-history touch_css"
    id="chat-history"
    v-chat-scroll
    @scroll-top="loadNewData"
    v-loading.fullscreen.lock=" this.lazyload.fullscreenLoading"
  >
    <ul>
      <message v-for="(message, index) in ChatHistory" :index="index" :key="index" :data="message"></message>
    </ul>
  </div>
  <!-- end chat-history -->
</template>

<script>
import Message from "@/components/Message";
import Global from "@/components/Global";
import { ChatLogHandler } from "@/handler/ChatLogHandler.js";

function scrollBottom() {
  if (this.lazyload.status === true) {
    this.lazyload.status = false;

    $("#chat-history").animate(
      {
        scrollTop: $("#comment").offset().top
      },
      10
    );

    return false;
  }
  $("#chat-history").animate(
    {
      scrollTop: this.$el.scrollHeight
    },
    10
  );
}

export default {
  name: "chat-log",
  props: ["messages"],
  components: {
    Message
  },
  data() {
    return {
      showTypingIndicator: false,
      fullscreenLoading: false,
      lazyload: { status: false, scrollbarHeigth: "", fullscreenLoading: false }
    };
  },
  computed: {
    ChatHistory: function() {
      this.$nextTick(scrollBottom);
      return this.messages;
    }
  },
  created() {},

  methods: {
    //scroll top 載入舊訊息
    loadNewData: function() {
      this.lazyload.fullscreenLoading = true;
      var messages_ = ChatLogHandler.GetHistory(this.ChatHistory.length);
      for (var i = 0; i < messages_.length; i++) {
        this.messages.unshift({
          frmId: messages_[i].frmId,
          UserName: messages_[i].UserName,
          Text: messages_[i].Text,
          msgTime: this.convertUTCDateToLocalDate(messages_[i].msgTime),
          msgType: messages_[i].msgType,
          filePath: messages_[i].filePath,
          previewImageUrl: messages_[i].previewImageUrl,
          senderType: messages_[i].senderType,
          ProfilePictureUrl: messages_[i].ProfilePictureUrl
        });
      }
      this.lazyload.status = true;
      this.lazyload.fullscreenLoading = false;
    }
  }
};
</script>
 <style scoped>
.touch_css {
  -webkit-overflow-scrolling: touch;
}

</style>




// WEBPACK FOOTER //
// src/components/ChatLog.vue